import { SettingDescription, SettingValue, type SettingBankDefinition, type SettingId } from "./lib/Settings";

export const GuidedSceneSettingIds = {
    IsMusicAPlaylist: "isMusicAPlaylist",
    MusicCrossfadeEnabled: "musicCrossfadeEnabled",
    StartMusicWhenStartingScene: "startMusicWhenStartingScene",
    AdvancedAmbienceLoopControls: "advancedAmbienceLoopControls",
}

export type GuidedSceneSettings = "marker";

export const GuidedSceneSettingDescriptions: SettingBankDefinition = {
    IsMusicAPlaylist: new SettingDescription<boolean>({
        id: GuidedSceneSettingIds.IsMusicAPlaylist,
        description: "Treat Music as a playlist",
        tooltip: "Only play a song at a time. Automatically play the next song in \"Music\" when the current one ends.",
        defaultValue: true,
        isExperimental: false,
    }),
    MusicCrossfadeEnabled: new SettingDescription<boolean>({
        id: GuidedSceneSettingIds.MusicCrossfadeEnabled,
        description: "Cross-fade Music tracks",
        tooltip: "Transition smoothly between tracks in \"Music\".",
        defaultValue: false,
        isExperimental: true,
    }),
    StartMusicWhenStartingScene: new SettingDescription<boolean>({
        id: GuidedSceneSettingIds.StartMusicWhenStartingScene,
        description: "Start Music when playing scene",
        tooltip: "Start playing tracks from \"Music\" when clicking the \"Play Scene\" button.",
        defaultValue: false,
        isExperimental: true,
    }),
    AdvancedAmbienceLoopControls: new SettingDescription<boolean>({
        id: GuidedSceneSettingIds.AdvancedAmbienceLoopControls,
        description: "Advanced Ambience controls",
        tooltip: "Enable advanced Ambience controls, such as finer control over looping",
        defaultValue: true,
        isExperimental: true,
    }),
}
